<div #selector class="multilevel-selector" [ngClass]="{'multilevel-selector-disabled':!data[0].childs!.length}">
    <div class="multilevel-selector-head" [ngClass]="{'multilevel-selector-head-opened':showDropdown,'multilevel-selector-head-placeholder':!multilevelSelectorHeadNumber}"
        (click)="toogleDropdown()">
        <span>
            {{multilevelSelectorHeadNumber > 1 ? '('+multilevelSelectorHeadNumber+')' : ''}}
            {{ multilevelSelectorHead | translate }}
        </span>

    </div>
    <span *ngIf="clearSelectorPB" (click)="clear($event)" class="ng-clear-wrapper" title="Clear all"><span
        aria-hidden="true" class="ng-clear">×</span></span>
    <div *ngIf="showDropdown" class="multilevel-selector-dropdown">
        <div *ngFor="let item of data; index as i">
            <div class="multilevel-selector-dropdown-search-container">
                <input type="search" class="form-control" [placeholder]="'DATATABLE.SEARCH' | translate"
                    [(ngModel)]="selectorSearch" (ngModelChange)="onChangeSearch($event,'search')"
                    (keyup)="applyFilters()" [ngModelOptions]="{standalone: true}">
            </div><!--|| typeData == 'newPackage'-->
            <div *ngIf="typeData == 'newDevice'  || typeData == 'newUser' || ( typeData != 'newUser' && item.target.entityTypeId != 1)"
                [className]="'multi-level-item'+(item!.selected ? ' multi-level-item-selected' : '')">
                <div (click)="toogle(item)">
                    <span>{{item.target.name}}</span>
                </div>
                <input id="entity-multilevel-item-{{ i }}" type="checkbox" [(ngModel)]="item!.selected"
                    (change)="change($event,item)" />
                <!--<input *ngIf="(typeData != 'user' && typeData != 'newUser')
                || (typeData === 'user' && item.target.entityTypeId === userEntity?.roleId) 
                || (typeData === 'newUser' && item.target.entityTypeId === max)"
                    id="entity-multilevel-item-{{ i }}" type="checkbox" [(ngModel)]="item!.selected"
                    (change)="change($event,item)" />-->
            </div>
            <div *ngIf="item.opened" class="multi-level-item-container">
                <hbo-single-select-multi-level-item [userEntity]="userEntity" [hidden]="!item.visible"
                    [typeData]="typeData" [search]="selectorSearch" [item]="item" [data]="item.childs"
                    [selected]="item.selected" (callbackVisible)="visibleEntity($event)"
                    (callback)="setEntity($event)"
                    [max]="max"></hbo-single-select-multi-level-item>
            </div>
        </div>
    </div>
</div>